<router-outlet />
<!-- Created only while open, so its data loads on demand (not on the login page). -->
@if (orderPreview.current()) {
  <pp-order-preview-modal />
}
<pp-toast-container />
<pp-confirm-dialog />
